<template>
    <div class="news-content-container">
      <back-open-chenter />
      <div class="news-content-panel">
        <div class="news-title">业界最全！腾讯优图联合上海交通大学推出大模型指令微调数据集评测体系</div>
        <div class="news-date">2024年8月27日</div>
        <div class="news-content">
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
            </div>
          </div>
          <p>
            想快速迭代垂直细分领域小模型，数据不够怎么办？
          </p>
          <p>
            开源数据似大海，怎么找到高质量的SFT数据？
          </p>
          <p>
            训练资源吃紧，来不及遍历百千万级的SFT数据，如何靠采样实现「四两拨千斤」？
          </p>
          <p>
            随着大规模语言模型（LLMs）的快速发展，指令调优在提升模型性能和泛化能力方面发挥着至关重要的作用。然而，在众多相关研究中，对于指令调优数据集的数据评估和选择方法尚未形成统一的体系，且缺乏全面深入的综述。
          </p>
          <p>
            近日，我们联合上海交通大学发布了一篇完整综述进行梳理，在最新的综述论文中深入分析了现有数据质量评估与采样筛选的WW手段，首次全面地梳理了大模型指令微调数据集的评估维度，并在统一的框架下对数据筛选采样的方法进行了细致介绍。
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/newscenter/news59.png"/>
            </div>
          </div>
          <div class="download-article-wrap">
            <p>
              项目主页：
            </p>
            <p>
              https://github.com/yuleiqin/fantastic-data-engineering
            </p>
            <p>
              论文链接：
            </p>
            <p>
              https://arxiv.org/abs/2408.02085
            </p>
          </div>
          <div class="news-content-mark">
            <div>1 研究背景和目标</div>
          </div>
          <p>
            · 背景：LLMs的发展目标是解锁对自然语言处理（NLP）任务的泛化能力，指令调优在其中发挥重要作用，而数据质量对指令调优效果至关重要。
          </p>
          <p>
            · 目标：统一指令调优数据集的数据评估和选择方法，从质量、多样性和重要性三个方面进行分类和阐述。
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news59/news59_1.png"/>
            </div>
          </div>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news59/news59_2.png"/>
            </div>
          </div>
          <div class="news-content-mark">
            <div>2 数据准备和评估选择概述</div>
          </div>
          <p>
            <span class="mark-text highlight">指令数据集准备：</span>
            文本样本通常由指令（System Prompt）、输入和响应三部分组成，通过预训练的LLM参数化的指令模板将样本包装成特定格式，并进行分词处理。
          </p>
          <p>
            <span class="mark-text highlight">指令监督：</span>
            通过交叉熵损失进行监督调优，模型根据指令上下文和响应完成情况迭代预测下一个token。
          </p>
          <p>
            <span class="mark-text highlight">数据评估和选择：</span>
            从整个数据集中找到最具信息量/最优质的子集，需要对每个数据点进行定量评估和精心设计的采样机制，以减少噪声、平衡数据分布和加速训练。
          </p>
          <p class="short-center">
            <strong>质量评估与选择</strong>
          </p>
          <p>
            <span class="mark-text highlight">概述：</span>
            “质量”主要指指令响应数据点的完整性、准确性和合理性，现有方法通常制定统一的评分机制来综合考虑这些维度。
          </p>
          <p>
            <span class="mark-text highlight">手工设计指标：</span>
            通过手工设计的指标（如词汇、句法、语义相似性等）来评估数据质量，指标计算明确，但无法检测不匹配的指令响应对。
          </p>
          <p>
            <span class="mark-text highlight">基于模型的指标：</span>
            利用可训练模型（如使用困惑度、多维评分评估器等）预测指标，结合多种训练感知指标（如不确定性、奖励分数等）的混合技术在选择无偏高质量样本方面具有潜力。
          </p>
          <p>
            <span class="mark-text highlight">大语言模型打分：</span>
            以调用闭源模型 API 服务的方式、或者部署开源大语言模型的方式等来对指令调优数据集进行自动评分，强大的语言模型已经与人类偏好高度对齐，可用于数据质量评分。此外，也可基于经过语言模型评分的少量样本，使用开源轻量级LLM 进行微调获得专家打分模型，能够减少成本，提升大规模数据打分的推理效率。
          </p>
          <p>
            <span class="mark-text highlight">人工评价：</span>
            在构建偏好对齐数据集时不可或缺，通过人工标注和评估为模型训练提供高质量数据，但存在标注不一致问题，需制定详细指南并辅以GPT评分等补充质量措施。
          </p>
          <p class="short-center">
            <strong>多样性评估与选择</strong>
          </p>
          <p>
            <span class="mark-text highlight">概述：</span>
            多样性指指令数据集的个体多样性（如词汇和语义丰富度）和整体多样性（如数据分布），选择具有多样性的数据集可增强模型的泛化能力。
          </p>
          <p>
            <span class="mark-text highlight">手工设计的指标：</span>
            包括词汇多样性（如Type-Token Ratio、vocd-D、MTLD、HD-D等）和语义多样性（如通过k – NN计算邻居距离、利用BERT嵌入计算方差等）等多种指标。
          </p>
          <p>
            <span class="mark-text highlight">基于模型的指标：</span>
            通过熵相关方法（如vanilla entropy、Rényi entropy、Simpson’s Index、Vendi Score等）、Task2Vec嵌入、开放标签的多样性标记等方式评估多样性。
          </p>
          <p>
            <span class="mark-text highlight">基于几何特征的Coreset采样：</span>
            通过k-center greedy、herding等方法选择最具信息和多样性的子集，代表整个数据集，使模型在子集上的训练性能接近在整个数据集上的训练性能，聚类技术在其中起到解释数据结构的作用
          </p>
          <p>
            <span class="mark-text highlight">基于Bi-level的Coreset采样：</span>
            将Coreset采样视为Bi-level优化问题，通过优化硬掩码或软权重来选择子集，涉及到模型内部参数的优化和数据选择的外部循环，一些方法通过引入验证集、梯度匹配和优化技术等来提高鲁棒性和效率。
          </p>
          <p class="short-center">
            <strong>重要性评估与选择</strong>
          </p>
          <p>
            <span class="mark-text highlight">概述：</span>
            重要性指添加一个指令响应样本对训练模型的必要性，与模型性能和任务相关，易样本可能不需要额外调优，而难样本对模型训练至关重要。
          </p>
          <p>
            <span class="mark-text highlight">手工设计的指标：</span>
            通过可读性指标（如语法、词汇、推理依赖等）评估文本难度，选择具有挑战性的样本以评估模型鲁棒性和构建有区分度的NLP基准。
          </p>
          <p>
            <span class="mark-text highlight">基于模型的指标：</span>
            包括不确定性（如prompt uncertainty）、奖励分数（通过奖励模型判断样本对模型行为的必要性）和数据模型（如通过Data model预测数据点对模型行为的影响、DSIR根据分布相似性估计重要性分数、MATES连续选择最有效子集、Xie等人通过重要性重采样选择类似目标分布的样本）等方式。
          </p>
          <p>
            <span class="mark-text highlight">基于Loss和Error的Coreset采样：</span>
            通过记录训练中样本的错误（如forgetting score、memorization、influence等）来估计重要性，选择对损失贡献大或导致性能差的样本，一些研究通过迭代近似和小代理模型加速计算边际效应。
          </p>
          <p>
            <span class="mark-text highlight">基于梯度的Coreset采样：</span>
            利用梯度直接影响语言模型优化的特性，通过梯度匹配（如逼近整个数据集的梯度）和梯度基于的影响（如通过上加权梯度乘法测量样本对模型参数的影响）来选择数据，一些技术（如低秩梯度相似性搜索、移动样本近似等）用于加速计算和提高效率，同时需要考虑近似的精度和效率。
          </p>
          <div class="news-content-mark">
            <div>3 结果与讨论</div>
          </div>
          <p>
            <span class="mark-text highlight">不同方法分类及实验结果总结：</span>
            根据质量、多样性、重要性对方法进行分类总结，并列出相关数据集和数据量。质量方面，基于质量选择数据可在使用较少数据时匹配全数据训练结果，且优于随机选择部分数据；多样性方面，引入多样数据集可增强模型泛化能力，结合质量和多样性的标准能取得更好性能；重要性方面，重要性数据选择结合数据选择和模型训练，通过点数据影响和参数化来提升最终性能。
          </p>
          <p class="short-center">
            <strong>现有挑战和未来方向</strong>
          </p>
          <p>
            <span class="mark-text highlight">基准测试：</span>
            数据选择的有效性与模型在基准测试上的性能报告之间存在差距，原因包括评估损失与基准性能相关性不强、测试集污染等，未来需要构建专门的基准来评估指令调优模型和所选数据点，并解耦数据选择和模型评估以排除数据污染的影响。
          </p>
          <p>
            <span class="mark-text highlight">“好”数据的定义：</span>
            目前没有统一标准来区分“好”“坏”指令，现有质量测量方法具有特定任务导向性且缺乏解释性，未来需要更统一、通用的定义和提高选择管道的可解释性，以适应不同下游任务的需求。
          </p>
          <p>
            <span class="mark-text highlight">数据集规模扩大：</span>
            随着数据集的扩大，确定最佳选择比例变得困难，原因包括噪声增加、过拟合和遗忘问题，建议通过质量测量方案、强调多样性和考虑与预训练数据的相似性来确定最佳选择比例，并优化数据评估和选择的可扩展性pipeline。
          </p>
          <p>
            <span class="mark-text highlight">LLMs规模扩大：</span>
            随着LLMs规模增大，数据评估和选择的成本效率降低，需要发展高效的代理模型，同时重新思考传统机器学习技术，如优化技巧和降维方法，此外，目前实验多在小中型LLMs上进行，未来需要验证在大型LLMs上的效率。
          </p>
          <p class="short-center">
            <strong>结论</strong>
          </p>
          <p>
            本文全面Survey了LLMs指令调优的数据评估和选择方法，统一组织并分类，详细阐述了各维度的代表性策略和数据选择因素，报告了典型方法的性能并进行比较讨论，总结了现有挑战和未来研究的潜在解决方案，以期有益于研究社区。本文通过全面、系统、深入的分析，为读者提供了一个关于LLMs指令调优数据评估和选择方法的综合指南，具有重要的理论和实践意义。
          </p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
  export default {
    name: 'News59',
    components: {
      BackOpenChenter
    }
  };
  </script>
  
  <style lang="less" scoped>
  @import "./news.less";
  .news-content {
    margin: 0 auto;
    .image-panel {
      max-width: 667px;
      text-align: center;
      img {
        max-width: 667px;
      }
      span {
        font-size: 12px;
        color: #858585;
      }
    }
    .highlight {
      color: #0052FF;
    }
    .end-divide {
      width: 120px;
      height: 2px;
      margin: 20px auto;
      background: #0152d9;
    }
    .download-article-wrap {
      margin: 0 auto;
      padding: 5px 3px;
      border: 3px solid rgb(1, 82, 217);
      font-family: PingFangSC-light;
      .download-article {
        padding: 5px 10px;
        border-left: 1px solid rgb(1, 82, 217);
        border-right: 1px solid rgb(1, 82, 217);
      }
    }
    .news-literature {
      max-height: 180px;
      padding: 15px;
      overflow-y: scroll;
      background-color: #ebebeb;
    }
    .short-center{
      text-align: center;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News59.vue